import { Component, inject, HostListener } from '@angular/core';
import { FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { AppRightDrawer } from '../../../app-services/right-drawer/right-drawer.app';

import { Helpers } from '../../../helpers/helpers';
import { Router } from '@angular/router';

@Component({
  selector: 'app-geolocation-details',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatDividerModule, MatIconModule],
  templateUrl: './geolocation-details.component.html',
  styleUrl: './geolocation-details.component.scss'
})
export class GeolocationDetailsComponent {
  private readonly serviceRightDrawer = inject(AppRightDrawer);
  private readonly router = inject(Router);

  geolocationForm = new FormGroup({
    question: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(500)])
  });

  constructor() {
    const question = this.router.GetNavigationParameter(GeolocationDetailsComponent);
    this.geolocationForm.patchValue({
      question: question as string ?? ''
    });
  }

  onUpdate(): void {
    if (this.geolocationForm.valid) {
      const questionValue = this.geolocationForm.controls.question.value;
      console.log('Location question updated:', questionValue);
      // Implement your update logic here
      this.serviceRightDrawer.close({
        status: true,
        question: questionValue
      });
    }
  }

  onClose(): void {
    // Implement your update logic here
    this.serviceRightDrawer.close({
      status: false,
      question: undefined
    });
  }

  //#region Test Data Population
  // This method is for testing purposes to populate the form with sample data

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    // Check for Ctrl+Shift+1 (the key code for '1' is '1', but with shift it becomes '!')
    if (event.ctrlKey && event.shiftKey && (event.key === '1' || event.key === '!')) {
      console.log('Keyboard shortcut detected: Ctrl+Shift+1');
      this.populateTestData();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  populateTestData(): void {
    this.geolocationForm.patchValue({
      question: `Where did you visit to purchase this item? Please share your location so we can verify your entry. [${Helpers.guid
        .generateTimeGuid()
        .substring(0, 8)}]`
    });

    console.log('Test data populated successfully!');
  }

  //#endregion
}
